module.exports = __webpack_public_path__ + "static/media/setpoint-CWU-czuwanie.e4d89adb.svg";